<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-distribution-notes"
          v-if="auth.can('ADD_BDIS') && auth.can('BDIS')"
        >
          Ajouter un bon de distribution
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'note_ref'">
            <b>{{ props.row.note_ref }}</b>
          </template>

          <template v-else-if="props.column.field === 'zone_name'">
            <b>{{ props.row.zone_name }}</b
            ><br />
            {{ props.row.note_agency }}
          </template>

          <template v-else-if="props.column.field === 'created_at'">
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}
              <br />
            </template>
            {{ props.row.note_by_name }}
          </template>
          <!-- <span
            v-else-if="props.column.field === 'note_saved_time'"
            class="text-nowrap"
          >
            <h5 v-if="props.row.note_saved_time!=null">{{ getDate(props.row.note_saved_time) }}</h5>
            <center><span>{{props.row.note_saved_by_name}}</span></center>
          </span> -->

          <template v-else-if="props.column.field === 'note_save'">
            <span
              v-if="props.row.note_save == 0"
              class="badge text-bg-warning fs-13"
            >
              Brouillon
            </span>
            <span v-else class="badge text-bg-success fs-13"> Enregistré </span>
          </template>

          <template v-else-if="props.column.field === 'note_parcels_num'">
            <div class="d-flex align-items-center gap-2 text-nowrap">
              <b>{{ props.row.note_parcels_num }}</b>
              <router-link
                v-if="props.row.note_parcels_num != 0"
                class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                :to="tourRoute(props.row)"
                title="Colis triés du plus proche au plus loin"
              >
                <i class="ph ph-navigation-arrow" aria-hidden="true"></i>
                Tournée
              </router-link>
            </div>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <button
                    v-if="auth.can('BDIS')"
                    class="dropdown-item d-flex align-items-center"
                    @click="showModalNormal(props.row)"
                  >
                    <!-- v-b-modal.modal_NoramlBe -->
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li
                  v-if="
                    props.row.note_save == 0 && props.row.note_parcels_num == 0
                  "
                >
                  <button
                    v-if="auth.can('BDIS')"
                    class="dropdown-item d-flex align-items-center"
                    @click="removeNote(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.note_save == 0 && props.row.note_parcels_num != 0
                  "
                >
                  <button
                    v-if="auth.can('BDIS') && auth.can('SAVE_BDIS')"
                    class="dropdown-item d-flex align-items-center"
                    @click="saveBon(props.row)"
                  >
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Reçu
                  </button>
                </li>
                <li v-if="props.row.note_save == 0">
                  <router-link
                    v-if="auth.can('BDIS')"
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'AddColisDistrPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-edit lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>
                <li v-if="props.row.note_parcels_num != 0">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    :to="tourRoute(props.row)"
                  >
                    <i
                      class="ph ph-navigation-arrow lh-1 me-8 position-relative top-1"
                    ></i>
                    Tournée (plus proche)
                  </router-link>
                </li>
                <li v-if="props.row.note_parcels_num != 0">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </button>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <div class="modal fade" id="modal_ShowBe" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <ShowBonDist
            :rowBE="rowRef"
            :getRecords="getRecords"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal_NoramlBe" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <EditNote :rowBE="rowRef" :getRecords="getRecords" :isOpen="isOpen" />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { nextTick, onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { dt } from "@fullcalendar/core/internal-common";
import router from "@/router";

import ShowBonDist from "@/components/Notes/Distribution/ShowBonDist.vue";
import EditNote from "@/components/Notes/Distribution/EditNote.vue";

export default {
  name: "ListeNotes",
  components: {
    ShowBonDist,
    EditNote,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const rowRef = ref(null);

    const zonesList = ref([]);
    const transport = ref(null);
    const livreur = ref({ id: 0, name: null });

    const isOpen = ref(false);

    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Zone",
        field: "zone_name",
      },
      {
        label: "Livreur",
        field: "note_delivery_name",
      },
      {
        label: "Statut",
        field: "note_save",
      },
      {
        label: "Colis",
        field: "note_parcels_num",
      },
      {
        label: "Actions",
        field: "action",
      },
    ];

    // Declare missing refs for transportBon
    const TransRow = ref<{ id?: number; note_ref?: string } | null>(null);
    const transport_auto = ref({});
    const filters = reactive({
      searchTerm: "",
      searchZone: "",
      searchLiv: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchUser: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(async () => {
      getRecords();

      try {
        const res = await api.get(`api/auth/ListZone`);
        zonesList.value = res.data;
        zonesList.value.unshift({ id: "", name: "Tous" });
      } catch (error) {
        console.error("Error fetching zones:", error);
      }

      // try{
      //   const res = await api.get(`api/auth/LivsList`);
      //   livList.value = res.data;
      //   livList.value.unshift({ id: "", name: "Tous" });
      // }catch(error){
      //   console.error("Error fetching zones:", error);
      // }
    });
    async function getRecords(page = 1) {
      filters.current_page = page;
      isLoader.value = true;
      try {
        const response = await api.get(
          `/api/auth/list_bon_distr?liv_id=${user?.id}&searchZone=${filters.searchZone}&searchUser=${filters.searchUser}&searchLiv=${filters.searchLiv}&searchStatut=${filters.searchStatut}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function tourRoute(row) {
      return {
        name: "DistributionTourPage",
        params: { id: row.id, refNote: row.note_ref },
      };
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function filter() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   customer_filter = store_filter = { id: '', name: '' }
      //   date_filter = status_filter = type_date_filter = ''
      //   $refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }

    function convert(str: string) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function onSearchZones(search: string, loading: (state: boolean) => void) {
      if (search.length && zonesList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/ListZone`).then((res) => {
          zonesList.value = res.data.users.data;
          zonesList.value.unshift({ id: "", name: "Tous" });
          loading(false);
        });
      }
    }

    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/DISTPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function showModal(row) {

      rowRef.value = null;
      isOpen.value = false;

      await nextTick(); // wait for reset to be applied

      rowRef.value = row.note_ref; // assign new value
      isOpen.value = true;

      await nextTick(); // ensure DOM update

      const modalEl = document.getElementById("modal_ShowBe");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
    }

    async function showModalNormal(row) {
      rowRef.value = null; // reset first
      isOpen.value = false;

      await nextTick(); // wait for reset to be applied

      rowRef.value = row.note_ref; // assign new value
      isOpen.value = true;

      await nextTick(); // ensure DOM update

      const modalEl = document.getElementById("modal_ShowBe");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
    }

    async function removeNote(row) {
      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/RemoveDistNote/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon  est bien supprimé", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function saveBon(row) {
      let data = new FormData();
      // data.append('UserID', this.UserID.id);
      data.append("note_id", row.id);
      data.append("note_ref", row.note_ref);
      const result = await Swal.fire({
        text: "Vous voulez enregistrer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, enregistrer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/SaveBonDistr`, data);

          if (res.data.message === "success") {
            showToast("Bon  est bien enregistré", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas le enregistrer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }
    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      tourRoute,
      getDate,
      filter,
      convert,
      removeFilter,
      handleInput,
      getPDF,
      noteRow,

      onSearchZones,
      isOpen,

      transport,
      // Return missing refs
      TransRow,
      transport_auto,

      livreur,
      showModal,
      removeNote,
      saveBon,
      showModalNormal,

      rowRef,
    };
  },
};
</script>